import queryString from "query-string";

export const generateUrlToQuery = (query) => {
  let queries = { ...query };
  delete queries["slug"];

  let url = queryString.stringifyUrl({
    url: ``,
    query: {
      ...queries,
    },
  });

  return url;
};
